import { render, staticRenderFns } from "./DemoDisclaimer.vue?vue&type=template&id=1a5a22ca"
import script from "./DemoDisclaimer.vue?vue&type=script&lang=js"
export * from "./DemoDisclaimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports